import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import CreateAnnouncement, { ICreateAnnouncement, ICreateAnnouncementDispatchProps } from './CreateAnnouncement'
import { companyDivisionsSelector, managedCompaniesSelector } from '../../../Settings/store/SettingsSelectors'
import {
  getAnnouncementsFilters,
  getAnnouncementsLastUpdate,
  getAnnouncementsList,
} from '../../store/AnnouncementsSelectors'
import {
  createAnnouncement,
  editAnnouncement,
  getAnnouncementFilters,
  getAnnouncements,
} from '../../store/AnnouncementsActions'
import { getCompanyAdminSelectedCompanyId } from '../../../CompanyAdmin/store/CompanyAdminSelectors'
import { setCompanyAdminSelectedCompanyId } from '../../../CompanyAdmin/store/CompanyAdminActions'
import { getUserDto } from '../../../../common/auth/authSelectors'

const mapStateToProps = (state: IGlobalState, ownProps: any): ICreateAnnouncement => {
  const notificationId = ownProps.match.params.notificationId
  return {
    notificationId,
    announcements: notificationId ? getAnnouncementsList(state) : [],
    selectedCompanyId: getCompanyAdminSelectedCompanyId(state),
    managedCompanies: managedCompaniesSelector(state),
    filters: getAnnouncementsFilters(state),
    companyDivisions: companyDivisionsSelector(state),
    userDto: getUserDto(state),
    lastUpdate: getAnnouncementsLastUpdate(state),
  }
}

const mapDispatchToProps: ICreateAnnouncementDispatchProps = {
  setSelectedCompanyId: setCompanyAdminSelectedCompanyId,
  getAnnouncementFilters,
  getAnnouncements,
  createAnnouncement,
  editAnnouncement,
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateAnnouncement)
